module.exports = "/images/cu.svg?62559567595035f7bfd3a135a11fe90f";